module.exports = __webpack_public_path__ + "img/32.872230a7.png";